import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { TipoProduto } from 'src/app/core/enums/produto.enum';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { IAlertaCard } from './alerta-card/alerta-card.interface';
import { AlertaServiceAbstract } from './alerta.service.abstract';
import { Alerta } from './model/alerta.model';
import { IAlerta } from './model/alerta.interface';
import { IAlertaFilter } from './model/alerta.filter';
import { IMVProdutosProximoVencimento } from './model/mv-produtos-proximo-vencimento.interface';
import { IVWAlerta } from './model/vw-alerta.interface';
import { IProdutoAlertaEspecifico } from './alerta-card/lista-produto-especifico/model/produto-alerta-especifico-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertaService extends AlertaServiceAbstract {

  static URL = '/api/alerta/v1/alertas';

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandler,
      AlertaService.URL
    );
  }

  // FIXME: paginar alerta-home-cards
  public listarAlertaCardDTO(alertaFilter: IAlertaFilter): Observable<ListaResultset<IAlertaCard>> {
    const params = DefaultService.converterFiltroParaHttpParam(alertaFilter);

    return this.httpClient.get<ListaResultset<IAlertaCard>>(`${AlertaService.URL}/listarAlertaCardDTO`, {params})
               .pipe (
                  map((pageAlertas: ListaResultset<IAlertaCard>) => {

                    // typescript não entende se definir como a interface IAlertaCard
                    let novoArrayDeAlertas: IAlertaCard[] = [];

                    for ( let i = 0; i < pageAlertas.content.length; i++ ) {
                      const alerta = (pageAlertas.content[i]) as unknown as IAlertaCard;

                      if ( alerta.gatilhosGenericos ) {
                        alerta.gatilhosGenericosLista = JSON.parse(alerta.gatilhosGenericos);
                      }
                      else {
                        alerta.gatilhosGenericosLista = [];
                      }
                      novoArrayDeAlertas.push(alerta);
                    }
                    pageAlertas.content = novoArrayDeAlertas;

                    return pageAlertas;
                  })
                  ,catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                  })
               );
  }

  public criarAlerta(alerta: IAlerta): Observable<any> {
    return this.httpClient.post<any>(AlertaService.URL, alerta)
               .pipe (
                  map ( response => {
                    return response;
                  })
                  , catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                  })
                );
  }

  public removerAlerta(idAlerta: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(AlertaService.URL + '/' + idAlerta)
               .pipe (
                map ( response => {
                  console.log(response);
                  return response;
                })
                , catchError (err => {
                  return throwError(this.errorHandler.handle(err));
                })
              );
  }

  public buscarAlertaCardDTO(idAlerta: number): Observable<IAlertaCard[]> {
    return this.httpClient.get<IAlertaCard[]>(`${AlertaService.URL}/buscarAlertaCardDTO/${idAlerta}`, {})
               .pipe (
                  map((alertas: IAlertaCard[]) => {
                    for ( let alerta of alertas ) {
                      if ( alerta.gatilhosGenericos ) {
                        alerta.gatilhosGenericosLista = JSON.parse(alerta.gatilhosGenericos);
                      }
                      else {
                        alerta.gatilhosGenericosLista = [];
                      }
                    }
                    return alertas;
                  }),
                  catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                  })
                );
  }

  public getGatilhos(): string[] {
    return new Alerta().getGatilhos();
    
  }

  public listarProdutoAlertaEspecifico(tipoProduto: TipoProduto
                                       , descricaoProduto: string
                                       , statusProduto: string): Observable<ListaResultset<IProdutoAlertaEspecifico[]>> {
    let params: any = {
      'tipoProduto': tipoProduto,
      'descricaoProduto': descricaoProduto,
      'statusProduto': statusProduto
    };
    params = DefaultService.converterFiltroParaHttpParam(params);

    return this.httpClient.get<ListaResultset<IProdutoAlertaEspecifico[]>>(AlertaService.URL + '/listarProdutoAlertaEspecifico', {params})
               .pipe (
                 catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                })
               );
  }

  public listarProdutosVencidos() {
    return this.httpClient.get<IMVProdutosProximoVencimento[]>(`${AlertaService.URL}/listarProdutosVencidos`, {})
               .pipe (
                  // map((itens: IMVProdutosProximoVencimento[]) => {
                  // }),
                  catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                  })
                );
  }

  public listarAlertas() {
    return this.httpClient.get<IVWAlerta[]>(`${AlertaService.URL}/listarAlertas`, {})
               .pipe (
                  catchError (err => {
                    if ( err.status === 403 ) {
                      return throwError(err);
                    }
                    else {
                      return throwError(this.errorHandler.handle(err));
                    }
                  })
                );
  }
}
